import { render, staticRenderFns } from "./TextPanelToolbar.vue?vue&type=template&id=7b4450b3&scoped=true&"
import script from "./TextPanelToolbar.vue?vue&type=script&lang=js&"
export * from "./TextPanelToolbar.vue?vue&type=script&lang=js&"
import style0 from "./TextPanelToolbar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TextPanelToolbar.vue?vue&type=style&index=1&id=7b4450b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4450b3",
  null
  
)

export default component.exports